import { render, staticRenderFns } from "./NotExist.vue?vue&type=template&id=f22353fe&scoped=true&lang=pug&"
import script from "./NotExist.vue?vue&type=script&lang=js&"
export * from "./NotExist.vue?vue&type=script&lang=js&"
import style0 from "./NotExist.vue?vue&type=style&index=0&id=f22353fe&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22353fe",
  null
  
)

export default component.exports